module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("手风琴")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('uk-alert', {
    attrs: {
      "color": "danger"
    }
  }, [_c('uk-icon', {
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("注:")]), _vm._v(" 持续更新中...\n  ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-603796e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkAccordion.doc.vue
// module id = 296
// module chunks = 2